//common
require('../../assets/sprite/common/system/arrow-back.svg')
require('../../assets/sprite/common/system/btn-square.svg')
require('../../assets/sprite/common/system/cross.svg')
require('../../assets/sprite/common/system/docs.svg')
require('../../assets/sprite/common/system/download.svg')
require('../../assets/sprite/common/system/home.svg')
require('../../assets/sprite/common/system/geo.svg')
require('../../assets/sprite/common/system/rotate-left.svg')
require('../../assets/sprite/common/system/rotate-right.svg')
require('../../assets/sprite/common/system/search-xl.svg')
require('../../assets/sprite/common/system/search.svg')

require('../../assets/sprite/common/d-menu/auto.svg')
require('../../assets/sprite/common/d-menu/instrum.svg')
require('../../assets/sprite/common/d-menu/lifts.svg')
require('../../assets/sprite/common/d-menu/thermo-b.svg')
require('../../assets/sprite/common/d-menu/tires.svg')

require('../../assets/sprite/common/info.svg')

//social
require('../../assets/sprite/common/social/vk.svg')
require('../../assets/sprite/common/social/tg.svg')
require('../../assets/sprite/common/social/fb.svg')
require('../../assets/sprite/common/social/ig.svg')
require('../../assets/sprite/common/social/yt.svg')
require('../../assets/sprite/common/social/dz.svg')
require('../../assets/sprite/common/social/rt.svg')
require('../../assets/sprite/common/social/nm.svg')
require('../../assets/sprite/common/social/rutube.svg')

//bonus
require('../../assets/sprite/bonus/arrow-point.svg')
require('../../assets/sprite/bonus/box.svg')
require('../../assets/sprite/bonus/build.svg')
require('../../assets/sprite/bonus/calc.svg')
require('../../assets/sprite/bonus/geometry.svg')
require('../../assets/sprite/bonus/lock.svg')
require('../../assets/sprite/bonus/mount.svg')
require('../../assets/sprite/bonus/plug.svg')
require('../../assets/sprite/bonus/plus.svg')
require('../../assets/sprite/bonus/plus-corner.svg')
require('../../assets/sprite/bonus/squad.svg')
require('../../assets/sprite/bonus/switch.svg')

//why-me
require('../../assets/sprite/why-me/doc.svg')
require('../../assets/sprite/why-me/lider.svg')
require('../../assets/sprite/why-me/ok.svg')
require('../../assets/sprite/why-me/quality.svg')
require('../../assets/sprite/why-me/relatives.svg')
require('../../assets/sprite/why-me/smile.svg')

//logo
require('../../assets/sprite/logo/auto-red.svg')
require('../../assets/sprite/logo/auto-white.svg')
require('../../assets/sprite/logo/lft-dark.svg')
require('../../assets/sprite/logo/lft-light.svg')
require('../../assets/sprite/logo/meteor.svg')
require('../../assets/sprite/logo/thermo.svg')

//clients
require('../../assets/sprite/clients/domodedovo.svg')
require('../../assets/sprite/clients/harris.svg')
require('../../assets/sprite/clients/kamaz.svg')
require('../../assets/sprite/clients/nestle.svg')
require('../../assets/sprite/clients/pepsi.svg')
require('../../assets/sprite/clients/rosatom.svg')
require('../../assets/sprite/clients/rosneft.svg')
require('../../assets/sprite/clients/vw.svg')

//service
require('../../assets/sprite/service/calc-service.svg')
require('../../assets/sprite/service/case.svg')
require('../../assets/sprite/service/complex.svg')
require('../../assets/sprite/service/folder.svg')
require('../../assets/sprite/service/gear.svg')
require('../../assets/sprite/service/key.svg')
require('../../assets/sprite/service/like.svg')
require('../../assets/sprite/service/repeat.svg')
require('../../assets/sprite/service/water.svg')
